import React from "react";
import { useParams } from "react-router-dom";
import "./EventDetails.css";
import { Link } from "react-router-dom";

// Sample event data (should be shared in real app)
const events = [
  {
    id: 1,
    title: "Deliberative Debate Council",
    date: "2024-07-01",
    image: require("../img/DDCImage.png"),
    description: "The Deliberative Debate Council (DDC) is Unisfera MUNs signature committee, crafted to foster sharp reasoning, dynamic rebuttals, and meaningful consensus-building. With 25–30 assigned country delegates, the DDC combines the formal diplomacy of MUN with the open exchange of Lincoln-Douglas-style debate. Unlike traditional committees that follow strict rules of procedure, DDC encourages spontaneity, intellectual honesty, and fluid interaction. The emphasis is placed on the quality of arguments, logical consistency, and participants’ ability to collaborate toward actionable solutions.",
    descriptionTitle: "What is it?",
    formatTitle: "Rules of Procedure",
    formatDesc: [
      "Opening Statements: Each delegate delivers a structured 3-minute speech outlining their nation’s stance, core arguments, and proposed solutions.",
      "Cross-Examination: In this fast-paced 2-minute session, opposing delegates directly challenge each other’s claims through targeted questioning, testing logical consistency and preparation.",
      "Rebuttals: Delegates present counterarguments to critiques received, defending their position using evidence, rhetoric, and quick reasoning.",
      "Open Floor Clash: A dynamic 10–15 minute moderated round encouraging spontaneous, back-and-forth exchanges between delegates to uncover conflicts, forge alliances, and drive debate momentum.",
      "Lightning Round: In this high-pressure 30-second closing, each delegate delivers a concise and impactful final remark, reinforcing their stance and leaving a lasting impression."
    ]
  }
];

function EventDetails() {
  const { id } = useParams();
  const event = events.find(e => e.id === Number(id));

  return (
    <div className="event-details-container-all">
    <div className="event-details-bg">
      <div className="event-details-container">
        <div className="event-details-info">
        <h2 className="event-details-title">{event.title}</h2>
        <p className="event-details-date">{event.date}</p>
        <h3 className="event-details-desc-title">{event.descriptionTitle}</h3>
        <p className="event-details-desc">{event.description}</p>
        <h3 className="format-title">{event.formatTitle}</h3>
        <div className="event-details-desc">
          {event.formatDesc.map((point, idx) => {
            const colonIdx = point.indexOf(":");
            if (colonIdx !== -1) {
              return (
                <div key={idx}>
                  <span style={{ fontWeight: 'bold' }}>{point.slice(0, colonIdx + 1)}</span>
                  {point.slice(colonIdx + 1)}
                </div>
              );
            } else {
              return <div key={idx}>{point}</div>;
            }
          })}
        </div>
        <div className="to-register">
      <h2 className="to-register-title">What's next?</h2>
        <Link to="/register">
          <button className="register-button">REGISTER NOW!</button>
        </Link>
      </div>
        </div>  
        <img src={event.image} alt={event.title} className="event-details-image" />

      </div>
    </div>

    </div>
  );
}

export default EventDetails; 